import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/shifan.mp4';
const _withScopeId = n => (_pushScopeId("data-v-16331635"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-content"
};
const _hoisted_2 = {
  class: "content_left"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "box"
};
const _hoisted_5 = {
  class: "body-box"
};
const _hoisted_6 = {
  class: "box"
};
const _hoisted_7 = {
  class: "echarts"
};
const _hoisted_8 = {
  class: "box"
};
const _hoisted_9 = {
  class: "echarts"
};
const _hoisted_10 = {
  class: "right"
};
const _hoisted_11 = {
  class: "box"
};
const _hoisted_12 = {
  class: "body-box"
};
const _hoisted_13 = {
  class: "box"
};
const _hoisted_14 = {
  class: "echarts"
};
const _hoisted_15 = {
  class: "box"
};
const _hoisted_16 = {
  class: "echarts"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup"
}, null, -1));
const _hoisted_18 = {
  class: "center"
};
const _hoisted_19 = {
  class: "three"
};
const _hoisted_20 = {
  class: "content_right"
};
const _hoisted_21 = {
  class: "left"
};
const _hoisted_22 = {
  class: "box"
};
const _hoisted_23 = {
  class: "body-box"
};
const _hoisted_24 = {
  class: "box"
};
const _hoisted_25 = {
  class: "body-box"
};
const _hoisted_26 = {
  class: "box"
};
const _hoisted_27 = {
  class: "body-box"
};
const _hoisted_28 = {
  class: "right"
};
const _hoisted_29 = {
  class: "box"
};
const _hoisted_30 = {
  class: "body-box"
};
const _hoisted_31 = {
  class: "box"
};
const _hoisted_32 = {
  class: "body-box"
};
const _hoisted_33 = {
  class: "box"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "body-box"
}, [/*#__PURE__*/_createElementVNode("video", {
  src: _imports_0,
  style: {
    "width": "100%",
    "height": "100%"
  },
  controls: "",
  muted: "",
  autoplay: "",
  loop: "",
  id: "video1"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_headers = _resolveComponent("headers");
  const _component_parkInfo = _resolveComponent("parkInfo");
  const _component_borderBox = _resolveComponent("borderBox");
  const _component_searchScience = _resolveComponent("searchScience");
  const _component_scienceInnovation = _resolveComponent("scienceInnovation");
  const _component_weatherForecast = _resolveComponent("weatherForecast");
  const _component_rainFall = _resolveComponent("rainFall");
  const _component_accumulatedTemperature = _resolveComponent("accumulatedTemperature");
  const _component_photoSphereViewer = _resolveComponent("photoSphereViewer");
  const _component_climateMonitoring = _resolveComponent("climateMonitoring");
  const _component_greenhouseMonitoring = _resolveComponent("greenhouseMonitoring");
  const _component_iotDevice = _resolveComponent("iotDevice");
  const _component_plantArea = _resolveComponent("plantArea");
  const _component_harvestCondition = _resolveComponent("harvestCondition");
  const _component_plotDialog = _resolveComponent("plotDialog");
  const _component_weatherDialog = _resolveComponent("weatherDialog");
  const _component_greenhouseDialog = _resolveComponent("greenhouseDialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_headers), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("园区介绍")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_parkInfo)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("研学科普")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_searchScience)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("科技创新")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_scienceInnovation)])]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("天气预报")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_weatherForecast)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("降雨量")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_rainFall)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("累积积温")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_accumulatedTemperature)])]),
    _: 1
  })])]), _hoisted_17]), _createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("div", {
    class: "center_top",
    style: _normalizeStyle({
      fontSize: $data.fontSize + 'px',
      letterSpacing: $data.letterSpacing + 'px'
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(['text_content', {
      'scroll_paused': $data.showNoticeScroll == '0' ? true : $data.showNoticeScroll == '1' ? false : false
    }])
  }, _toDisplayString($data.noticeTitle), 3), $data.showNoticeScroll == '1' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(['text_content', {
      'scroll_paused': $data.showNoticeScroll == '0' ? true : $data.showNoticeScroll == '1' ? false : false
    }])
  }, _toDisplayString($data.noticeTitle), 3)) : _createCommentVNode("", true)], 4), [[_vShow, $data.showNotice == '0']]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_photoSphereViewer, {
    style: {
      "width": "100vw",
      "height": "100vh"
    },
    ref: "viewer",
    imgList: $data.photoList,
    onSelectMarker: $options.selectMarker
  }, null, 8, ["imgList", "onSelectMarker"])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("气候监测")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_climateMonitoring)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("温室监测")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_greenhouseMonitoring)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("物联设备")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createVNode(_component_iotDevice)])]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("种植面积")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_plantArea)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("收获情况(斤)")]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createVNode(_component_harvestCondition)])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_33, [_createVNode(_component_borderBox, null, {
    title: _withCtx(() => [_createTextVNode("长势监测")]),
    body: _withCtx(() => [_hoisted_34]),
    _: 1
  })])])])]), _createVNode(_component_plotDialog, {
    ref: "plotDialog"
  }, null, 512), _createVNode(_component_weatherDialog, {
    ref: "weatherDialog"
  }, null, 512), _createVNode(_component_greenhouseDialog, {
    ref: "greenhouseDialog"
  }, null, 512)], 64);
}